var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.816,
    height: 13.382,
    viewBox: "0 0 20.816 13.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "md-people",
    d: "M16.443,13.451A2.788,2.788,0,1,0,13.6,10.663,2.823,2.823,0,0,0,16.443,13.451Zm-7.569,0a2.789,2.789,0,1,0-2.839-2.788A2.822,2.822,0,0,0,8.874,13.451Zm0,2.045c-2.224,0-6.624,1.068-6.624,3.252v2.509H15.632V18.748c0-2.184-4.535-3.253-6.758-3.253Zm7.569.511a5.055,5.055,0,0,0-.811.046,2.77,2.77,0,0,1,1.487,2.695v2.509h5.948V18.748C23.066,16.564,18.666,16.007,16.443,16.007Z",
    transform: "translate(-2.25 -7.875)",
    fill: "#9a9797"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.43961c83.svg";
export { ForwardRef as ReactComponent };